import GearIcon from "../../../svg/GearIcon.vue";
import GroupIcon from "../../../svg/GroupIcon.vue";
import ChartsIcon from "../../../svg/ChartsIcon.vue";

export const advertisementIcons = [GroupIcon, GearIcon, ChartsIcon];
